// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PopoverBody-base__V5HB3{flex:1;height:auto;min-height:0;max-height:min(var(--popover-viewport-height) - 0px - 0px - 0px);max-height:min(var(--popover-viewport-height) - var(--popover-drag-indicator-height, 0px) - var(--popover-header-height, 0px) - var(--popover-footer-height, 0px));overflow-x:hidden;overflow-y:auto;scroll-behavior:smooth;-webkit-overflow-scrolling:touch}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "PopoverBody-base__V5HB3"
};
export default ___CSS_LOADER_EXPORT___;
